'use client';

import React__default from 'react';
import { LabelSelectResumeWrapper } from './AICVReview.css.js';
import AiCheckIcon from './AiCheckIcon.js';
import Typography from '../../Typography/index.js';
import { colors } from '../../Colors/index.js';
import AttachName from '../../AttachName/index.js';
import { convertDateTime } from '../../Utils/time.js';

var LabelSelectResume = function (props) {
    var t = props.t;
    var evaluateTime = convertDateTime(new Date(props.createdOn).getTime(), 7);
    return (React__default.createElement(LabelSelectResumeWrapper, null,
        React__default.createElement("div", { style: {
                height: 32,
                display: 'flex',
                alignItems: 'center',
                maxWidth: 32
            } },
            React__default.createElement(AiCheckIcon, { style: {
                    marginRight: 8
                } })),
        React__default.createElement("div", { style: { width: 'calc(100% - 32px)' } },
            React__default.createElement(Typography, { name: 'label', size: 'medium', style: { marginBottom: 4 } },
                React__default.createElement(AttachName, { fileName: props.fileName })),
            React__default.createElement(Typography, { name: 'label', size: 'small', color: colors.grey[50] },
                t('Evaluated on'),
                " ",
                evaluateTime))));
};

export { LabelSelectResume as default };
//# sourceMappingURL=LabelSelectResume.js.map
